import {useKey} from 'react-use';

import {ImageEditor, ImageEditorProps} from './ImageEditor';

type ImageEditorModalProps = ImageEditorProps;

export const ImageEditorModal = ({step, onChange, onClose}: ImageEditorModalProps) => {
  useKey('Escape', onClose);
  return (
    <div className="fixed inset-0 max-h-screen rounded-md bg-bg-muted">
      <ImageEditor step={step} onChange={onChange} onClose={onClose} />
    </div>
  );
};
